const Hero = () => {
  return (
    <div className="w-full pb-[177.87%] sm:pb-[53.333%] bg-mobileHero2023 sm:bg-webHero2023 bg-cover bg-center"></div>
  );
};

export default Hero;
